var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5354 1.54301L16.6991 5.80075L21.5566 6.48627C23.8322 6.8073 24.8723 9.61542 23.1182 11.2749L19.6291 14.5725L20.4503 19.2192C20.8708 21.5995 18.3444 23.1981 16.355 22.1845L11.9998 19.963L7.64589 22.1838C5.65353 23.2008 3.12923 21.5968 3.54925 19.2193L4.37042 14.5725L0.881876 11.2753C-0.873582 9.61467 0.170265 6.80715 2.4427 6.4863L7.3006 5.80072L9.46543 1.54301C10.511 -0.514246 13.49 -0.514426 14.5354 1.54301Z",
    fill: "#41D6C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/Rating.f6821f071b8592467c50a2fe49941d48.svg";
export { ForwardRef as ReactComponent };